module.exports = __webpack_public_path__ + "media/images/360/CBD_facts_woman_on_bed-2925ae49595df75c62e0d10d67a86d3a.webp";